var staticStrFirst = 'first'

module.exports = staticStrFirst



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.5.27/~/xe-utils/staticStrFirst.js
// module id = 166
// module chunks = 75